import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiShield, FiTruck, FiRefreshCw, FiHeadphones } from 'react-icons/fi';
import { SlideUp, FadeIn, StaggerContainer, StaggerItem } from '../animations';

const NewsletterSection = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <section className="bg-[#111111] relative overflow-hidden">
            {/* Concentric circles background effect */}
            <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
                <div className="w-[800px] h-[800px] rounded-full border-[0.5px] border-white/50 absolute"></div>
                <div className="w-[1100px] h-[1100px] rounded-full border-[0.5px] border-white/40 absolute"></div>
                <div className="w-[1400px] h-[1400px] rounded-full border-[0.5px] border-white/30 absolute"></div>
            </div>

            <div className="relative z-10 pt-24 pb-16 px-6 lg:px-12 text-center">
                {/* Header */}
                <SlideUp delay={0.1}>
                    <span className="block text-[#45b59c] text-[10px] md:text-[11px] font-semibold tracking-[0.25em] uppercase mb-4">{t('home.newsletter.subtitle')}</span>
                </SlideUp>
                <SlideUp delay={0.2}>
                    <h2 className="text-4xl md:text-5xl font-serif text-white mb-6">{t('home.newsletter.title')}</h2>
                </SlideUp>
                <SlideUp delay={0.3}>
                    <p className="text-white/70 text-sm md:text-base font-light mb-12 max-w-lg mx-auto">{t('home.newsletter.desc')}</p>
                </SlideUp>

                {/* Input Form */}
                <FadeIn delay={0.4}>
                <form onSubmit={handleSubmit} className="max-w-lg mx-auto flex flex-col md:flex-row mb-12">
                    <input
                        type="email"
                        placeholder={t('home.newsletter.placeholder')}
                        className="flex-1 bg-[#1a1a1a] border border-[#2a2a2a] py-4 px-6 text-white placeholder-gray-500 focus:outline-none focus:border-[#45b59c] transition-colors text-xs tracking-wider"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button
                        type="submit"
                        className="bg-[#45b59c] text-white px-8 py-4 text-xs font-bold tracking-[0.15em] hover:bg-[#3ca38c] transition-colors uppercase mt-4 md:mt-0"
                    >{t('home.newsletter.button')}</button>
                </form>
                </FadeIn>

                <FadeIn delay={0.5}>
                    <p className="text-[#555555] text-[10px] mb-8">{t('home.newsletter.privacy')}</p>
                </FadeIn>
            </div>

            {/* Trust Badges - Bottom Bar */}
            <div className="border-t border-[#222222] bg-[#111111] py-8 relative z-10">
                <StaggerContainer className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <StaggerItem className="flex items-center justify-center gap-3 text-white/80">
                        <FiShield className="text-[#45b59c] text-xl shrink-0" />
                        <span className="text-[10px] md:text-xs font-semibold tracking-wider uppercase whitespace-nowrap">{t('home.newsletter.ssl')}</span>
                    </StaggerItem>
                    <StaggerItem className="flex items-center justify-center gap-3 text-white/80">
                        <FiTruck className="text-[#45b59c] text-xl shrink-0" />
                        <span className="text-[10px] md:text-xs font-semibold tracking-wider uppercase whitespace-nowrap">{t('home.newsletter.shipping')}</span>
                    </StaggerItem>
                    <StaggerItem className="flex items-center justify-center gap-3 text-white/80">
                        <FiRefreshCw className="text-[#45b59c] text-xl shrink-0" />
                        <span className="text-[10px] md:text-xs font-semibold tracking-wider uppercase whitespace-nowrap">{t('home.newsletter.return')}</span>
                    </StaggerItem>
                    <StaggerItem className="flex items-center justify-center gap-3 text-white/80">
                        <FiHeadphones className="text-[#45b59c] text-xl shrink-0" />
                        <span className="text-[10px] md:text-xs font-semibold tracking-wider uppercase whitespace-nowrap">{t('home.newsletter.support')}</span>
                    </StaggerItem>
                </StaggerContainer>
            </div>
        </section>
    );
};

export default NewsletterSection;
